<template>
	<v-main class="pa-3" fluid>
    <v-row>
      <v-snackbar v-model="alerta.activo" multi-line :vertical="true" top right :color="alerta.color" :timeout="1000" > 
        <strong> {{alerta.texto}} </strong>
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
        </template>
      </v-snackbar>

      <v-col cols="12">
        <v-card class="shadowCard" height="auto">

          <v-card-title primary-title>
	  		    <span class="text-h6 font-weight-bold"> Pedido #{{ pedido.idpedidos }} </span>
	  		    <v-spacer></v-spacer>
            <v-card class="text-center pa-2 success " dark tile>
              <span class="font-weight-black">Total</span> <br>
              <span class="text-h6 font-weight-black">$ {{ pedido.total }}</span>
            </v-card>
	  		  </v-card-title>

          <v-row>
            <v-col cols="12">
              <v-card class="pa-4 subtitle-2 grey lighten-3" flat tile >
                <v-card-actions>
                  <div @click="openMaps">
                    <span class="font-weight-black"> {{ pedido.direccion }} </span><br> 
                    <span class="caption"> Abre google maps al dar click </span>
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn text @click="copyToClipboard">
                    <v-icon>mdi-content-copy</v-icon> <span class="hidden-sm-and-down">Copiar Texto</span> 
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col cols="12" >
              <v-simple-table  fixed-header class="custom-table">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left"> Artículo </th>
                        <th class="text-left"> Cantidad </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item2 in pedido.articulos" :key="item2.idproducto">
                      <!-- <tr v-for="item2 in 20" :key="item2.idproducto"> -->
                        <td class="subtitle-2">{{ item2.nomart }}</td>
                        <td class="subtitle-2">{{ item2.cantidad }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
            </v-col>

 


            <v-col cols="12" class="py-0">
              <v-card flat>
                <v-divider></v-divider>
                <v-card-text>
                  <v-file-input
                    small-chips
                    multiple
                    v-model="files"
                    :rules="rules"
                    filled
                    accept="image/png, image/jpeg, image/bmp"
                    placeholder="Selecciona tus imagenes"
                    prepend-icon="mdi-camera"
                    label="Imágenes"
                    @change="cargar()"
                    hide-details=""
                  ></v-file-input>
                </v-card-text>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" xl="2" lg="2" md="3" sm="4" xs="6" v-for="(img, i) in vistaPrevias" :key="i">
                      <v-card class="py-2">
                        <v-img :src="img.url" contain aspect-ratio="5">
                          <v-row align="end" class="lightbox white--text pa-2 fill-height">
                            <v-col align="right">
                              <v-btn color="error" samll @click="eliminarFoto(img.url)" icon><v-icon>delete</v-icon></v-btn>
                            </v-col>
                          </v-row>
                        </v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

       
            <v-col cols="12" >
              <v-card-actions class="pa-4" flat>
              <v-text-field
                v-model="costo_envio"
                label="Costo del envío"
                filled
                required
                hide-details
                type="number"
                dense
              ></v-text-field>

              
              <!-- <v-btn class="mx-1" small fab color="orange" dark @click="calcular_envio()"><v-icon>mdi-calculator-variant</v-icon></v-btn> -->
              <v-btn class="mx-2" small fab color="error" dark @click="costo_envio = 0">
                <v-icon >mdi-delete-outline</v-icon>
              </v-btn>

              </v-card-actions>
              <v-card class="pa-4" flat>
                <v-textarea
                  outlined
                  v-model="obs"
                  label="Agrega un comentario"	
                  rows="3"  
                  placeholder="Escribe aquí tus comentarios..." >
                ></v-textarea>
              </v-card>
             
            </v-col>

         
          </v-row>

          <div class="mt-6"></div>

          <v-footer absolute >
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="modalValidarAsignacion = true"> 
              Finalizar Entrega.
            </v-btn>
          </v-footer>
        </v-card>


      </v-col>
    </v-row>
    
    <v-dialog v-model="modalValidarAsignacion" persistent width="500">
      <v-card>
        <v-card-title class="subtitle-1 font-weight-black " style="word-break:normal;">¿ESTÁS SEGURO DE QUERER FINALIZAR EL PEDIDO ? </v-card-title>
        <v-divider class="my-0 py-3" ></v-divider>
        <v-card-subtitle align="center" class="red--text font-weight-bold "> UNA VEZ FINALIZADO NO PODRA CAMBIAR </v-card-subtitle>
        <v-divider class="my-0 py-2 " ></v-divider>
        <v-card-actions>
          <v-btn color="error" dark @click="modalValidarAsignacion=false" >  NO, Cancelar </v-btn>
          <v-spacer/>
          <v-btn color="primary" text @click="finalizarEntrega()" >  SÍ, Finalizar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

		<overlay v-if="overlay"/>
  </v-main>
</template>

<script>
  import  metodos from '@/mixins/metodos.js';
	import {mapGetters, mapActions} from 'vuex'
  // import loading from '@/components/loading.vue'
  import overlay from '@/components/overlay.vue'

  export default {
    mixins:[metodos],
	  components: {
			// loading,
      overlay
		},
		props:[
			'parametros',
	  ],

    data(){
      return{
        pedido: {},
        files: [], // Almacena las imágenes seleccionadas
        vistaPrevias:[],
        rules: [
          value => !value ,
        ],
        obs: '',
        costo_envio: 0, 
  
        // Loading: false,

        ObjectDefault:{},
        alerta: { activo: false, texto:'', color:'error' },
        overlay: false,

        // repartidores: [],
        // repartidor:{ id: null, nombre:'' },
        // obs_asignacion_repartidor: '',

        modalValidarAsignacion: false, 
      }
    },

    created(){
      if(!this.$route.params.item){  window.history.go(-1); } // SI NO OBTENGO LA INFORMACION 
        this.pedido = this.$route.params.item;
        this.initialize();
		},

    watch:{
    },
			
		computed:{
			// IMPORTANDO USO DE VUEX - CLIENTES (GETTERS)
      ...mapGetters('Login',['getusuarioFetish']),
		},

    methods:{
      
      async initialize(){
      },

      openMaps() {
        // Abre Google Maps con la dirección
        const direccion = this.pedido.direccion;
        const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(direccion)}`;
        window.open(url, '_blank');
      },

      copyToClipboard() {
        const direccion = this.pedido.direccion;
        const el = document.createElement('textarea');
        el.value = direccion;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        this.alerta = { activo:true, texto:'Direccion Copiada', color:'success'}
      },

      cargar(){
        if(this.files.length < 1){
          return
        }
        this.files.forEach((element, index) => {
          // creamos una variable tipo FormData
          let formData = new FormData();
          //se crea el objeto y se le agrega como un apendice el archivo 
          formData.append('file', element);
          //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
          console.log('formData', formData);
          this.getBase64(element, formData)
        })
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          me.vistaPrevias.push({
            url: reader.result, 
            formData: formData, 
            image_name: file.name
          })
        };
      },

      eliminarFoto(value){
      	this.vistaPrevias.forEach((element, index)=>{
      		if(element.url == value){
      			this.vistaPrevias.splice(index,1);
      		}
      	})
      },

      finalizarEntrega(){
        this.overlay = true;
        this.modalValidarAsignacion = false;

        if(this.vistaPrevias.length){
                  // Recorremos las imagenes previas cargadas para poder agregarlas al servidor y guardar el nombre en la base de datos
          this.vistaPrevias.forEach((element, index) => {
          
            const payload = {
              image_name: element.image_name,
              idseguimiento_pedidos: this.pedido.idseguimiento_pedidos,
              idpedidos: this.pedido.idpedidos,
              obs: this.obs,
              envio: this.costo_envio,
              proceso: 6
            }
            this.$http.post('finalizar.entrega', payload).then( response=>{
              // console.log('finalizar proceso', response.body);
              this.$http.post('imagenes', element.formData).then(response=>{ // Mandamos el formdata (archivo de la imagen) al servidor
                if(index == 0){
                  this.alerta = { activo: true, color:'success', texto: "Pedido Entregado correctamente" };
                  let that = this;
                  this.limpiarCampos();
                  setTimeout(()=>{ that.$router.push({ name:'pedidos_pendientes' })  }, 1000);
                }
              }).catch(error=>{
                this.alerta = { activo: true, color:'error', texto: "Ocurrio un error al guardar 1 o mas imagenes" };
                console.log(error)
              })
            }).catch(error=>{
              this.alerta = { activo: true, color:'error', texto: "Ocurrio un error al finalizar la entrega" };
              console.log(error)
            }).finally(()=>{ this.overlay = false})
          })
        }

        if(!this.vistaPrevias.length){

          const payload = {
            image_name: '',
            idseguimiento_pedidos: this.pedido.idseguimiento_pedidos,
            idpedidos: this.pedido.idpedidos,
            obs: this.obs,
            envio: this.costo_envio,
            proceso: 6
          }

          this.$http.post('finalizar.entrega', payload).then( response=>{
            this.alerta = { activo: true, color:'success', texto: "Pedido entregado correctamente" }
            let that = this;
            this.limpiarCampos();
            setTimeout(()=>{ that.$router.push({ name:'pedidos_pendientes' })  }, 1000);
          }).catch(error=>{
            this.alerta = { activo: true, color:'error', texto: "Ocurrio un error al finalizar la entrega" };
            console.log(error)
          }).finally(()=>{ this.overlay = false})

        }
        
      },

      limpiarCampos(){
        this.vistaPrevias = [];
        this.files = []
      }
    } 

  }
</script>

<style scoped>
  .custom-table {
    min-height: 'auto'; /* Establece aquí tu altura mínima */
    max-height: 200px; /* Establece aquí tu altura máxima */
    overflow-y: auto; /* Añade barras de desplazamiento vertical si el contenido excede la altura máxima */
  }
</style>
